import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import {
  BaseForm
} from '../../styles/BasicStyles';
import {
  Col
} from 'antd';
import { useSelector } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { withLocalize } from 'react-localize-redux';
import FormValidator from '../../infra/services/validations/FormValidator';
import TextInput from '../../components/inputs/TextInput';
import SelectInput from '../../components/inputs/SelectInput';

const validations = values => {
  let error = {};
  error = FormValidator.make({
    category: 'required',
    name: 'required',
    contact: 'required',
    email: 'required'
  })(values);

  return error;
};

let WeddingCanvaModal = (props): React$Element<React$FragmentType> => {
  const weddingCanvaForm = useSelector(state => {
    return state.form.wedding_canva_form?.values;
  });

  const [initialValues, setInitialValues] = React.useState(null);
  const [templates, setTemplates] = React.useState([]);
  const [loadingTemplates, setLoadingtemplates] = React.useState(false);

  useEffect(() => {
    setInitialValues(JSON.parse(JSON.stringify(props.initialValues)));
    setTemplates(props?.templates);
  }, [props.initialValues])

  useEffect(() => {
    if (weddingCanvaForm) {
      const data = JSON.parse(JSON.stringify(weddingCanvaForm));
      setInitialValues(data);
    }
  }, [weddingCanvaForm])

  const title = `${initialValues?._id === null ? 'Editar' : 'Adicionar'} canva`;

  return (
    <Modal
      visible={props.isOpen}
      title={title}
      maskClosable
      onCancel={props.onClose}
      width={window.outerWidth >= 1024 ? 700 : '90%'}
      footer={[
        <Button
          key='cancel'
          onClick={() => props.onClose()}>
          Cancelar
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={props.handleSubmit(props.onSubmit)}>
          Gravar
        </Button>
      ]}
    >
      <BaseForm onSubmit={props.handleSubmit(props.onSubmit)}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Field
            component={TextInput}
            name='name'
            label="Nome"
            type="text"
          />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Field
            component={SelectInput}
            name='template'
            label="Template"
            type="select"
            data={templates}
            dataKey={'key'}
            dataLabel={'value'}
            loading={loadingTemplates}
            disabled={initialValues?._id ? true : false}
          />
        </Col>
      </BaseForm>
    </Modal>
  );
};

const selector = formValueSelector('wedding_canva_form');

WeddingCanvaModal = reduxForm({
  form: 'wedding_canva_form',
  enableReinitialize: true,
  validate: validations
})(WeddingCanvaModal);

WeddingCanvaModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default withLocalize(WeddingCanvaModal);